import React, {useState} from 'react';

import ToolTipComponent from './toolTipComponent';

import './animatedStopButton.css';

const AnimatedStopButton = ({
  isDisabled = false,
  isMentorSide,
  toolTipPosition = 'top',
  toolTipTxt = '',
  onClick = () => {},
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  return (
    <div
      className={`et-animated-stop-button-container ${isDisabled ? 'et-animated-stop-button-container-disabled' : ''} ${!isMentorSide ? 'et-animated-stop-button-container-client' : ''}`}
      onMouseEnter={handleToolTip}
      onMouseLeave={handleToolTip}
      onClick={isDisabled ? null : onClick}>
      <div className="et-asbc-square" />
      {showToolTip && (
        <ToolTipComponent
          toolTipTxt={toolTipTxt}
          toolTipPosition={toolTipPosition}
        />
      )}
    </div>
  );
};

export default AnimatedStopButton;
